var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "add-params",
    attrs: {
      title: (_vm.status === "add" ? _vm.$t("添加") : _vm.$t("编辑")) + _vm.$t("参数"),
      visible: _vm.addVisible,
      width: 620
    },
    on: {
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("参数名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("参数代码"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.code,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "code", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.code"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文字说明"),
      prop: "description"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      "max-length": 200
    },
    model: {
      value: _vm.addForm.description,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "description", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.description"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件"),
      prop: "type"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.type,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "type", $$v);
      },
      expression: "addForm.type"
    }
  }, _vm._l(_vm.paramsTypeObj, function (value, key, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: key
      }
    }, [_vm._v(_vm._s(_vm.$t(value)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排序"),
      prop: "sort"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      min: 0
    },
    model: {
      value: _vm.addForm.sort,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "sort", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.sort"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否生成标签"),
      prop: "isTag"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.addForm.isTag,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "isTag", $$v);
      },
      expression: "addForm.isTag"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("否")) + " ")]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("是")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), _vm.status === "add" && _vm.isContinue ? _c("a-checkbox", {
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")))]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };